import useSite from "@casino/legacy/client/hooks/useSite";
import getEnv from "@casino/legacy/shared/utils/getEnv";
import parse from "@casino/legacy/shared/utils/string/parse";
import { getCookie } from "@workspace/cookies/browser";
import { LANGUAGE_COOKIE } from "@workspace/nextjs_utils/src/cookies/LANGUAGE_COOKIE";
import type { RefObject } from "react";
import Reaptcha from "reaptcha";
import Container from "./Container";

type Props = {
  onVerify?: (token?: string | null) => void;
  recaptchaRef?: RefObject<Reaptcha>;
};

const ReCAPTCHA: FC<Props> = ({ onVerify, recaptchaRef }) => {
  const { site } = useSite();
  const langCode = getCookie(LANGUAGE_COOKIE);

  const recaptchaV2ApiKeys = parse(
    getEnv("RECAPTCHA_V2_API_KEY") || "{}",
  ) as Partial<Record<Site, string>>;
  const sitekey = recaptchaV2ApiKeys[site] ?? "";

  const handleLoad = () => {
    if (recaptchaRef?.current) {
      setTimeout(() => {
        if (!recaptchaRef.current?.state.rendered) {
          recaptchaRef.current?.renderExplicitly();
        }
      }, 2000);
    }
  };
  return (
    <Container data-testid="recaptcha-form-error">
      <Reaptcha
        sitekey={sitekey}
        onVerify={onVerify}
        onExpire={onVerify}
        ref={recaptchaRef}
        onLoad={handleLoad}
        hl={langCode}
        explicit
      />
    </Container>
  );
};

export default ReCAPTCHA;
